var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleMovie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1308.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Movie",
    transform: "translate(2352.000000, 1308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,9 L29,9 L29,6 L24,6 L24,9 Z M24,26 L29,26 L29,23 L24,23 L24,26 Z M17,9 L22,9 L22,6 L17,6 L17,9 Z M17,26 L22,26 L22,23 L17,23 L17,26 Z M10,26 L15,26 L15,23 L10,23 L10,26 Z M3,9 L8,9 L8,6 L3,6 L3,9 Z M3,26 L8,26 L8,23 L3,23 L3,26 Z M20.5,16 L13.5,19.5 L13.5,12.5 L20.5,16 Z M10,9 L15,9 L15,6 L10,6 L10,9 Z M4,3 C1.791,3 0,4.791 0,7 L0,29 L28,29 C30.209,29 32,27.209 32,25 L32,3 L4,3 Z",
    id: 37
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleMovie);
export default __webpack_public_path__ + "static/media/life-and-people-movie.c280210f.svg";
export { ForwardRef as ReactComponent };